import React from "react";
import T from "prop-types";

import ZdrojeTabs from "b2b/components/zdroje-tabs/ZdrojeTabs";
import useRezervaceTabs from "./useRezervaceTabs";

export function RezervaceTabs({ datumOd, datumDo, stav }) {
  const { contentRenderer } = useRezervaceTabs({ datumOd, datumDo, stav });
  return (
    <div className="b2b-RezervaceTabs">
      <ZdrojeTabs contentRenderer={contentRenderer} />
    </div>
  );
}

RezervaceTabs.propTypes = {
  datumOd: T.instanceOf(Date),
  datumDo: T.instanceOf(Date),
  stav: T.string
};

export default React.memo(RezervaceTabs);
